import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20 pt-4" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = { class: "flex justify-end pt-3" }
const _hoisted_6 = { class: "pt-5 text-center" }
const _hoisted_7 = { class: "flex justify-center pt-3" }
const _hoisted_8 = { class: "pt-5" }
const _hoisted_9 = { class: "flex justify-center pt-3 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_Field = _resolveComponent("Field")!
  const _component_editor = _resolveComponent("editor")!
  const _component_NextButton = _resolveComponent("NextButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Loading, { visible: _ctx.loading }, null, 8, ["visible"])
    ])),
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.hasNinjaId)
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 0,
            class: "bg-next-orange mb-3"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("Non puoi creare una richiesta di supporto perché il tuo utente non è presente su ninja ")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "font-bold text-2xl pb-5" }, "Richiedi supporto", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Field, {
            modelValue: _ctx.subject,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.subject) = $event)),
            field_name: "Titolo",
            placeholder: "Titolo",
            errors: _ctx.getErrors('titolo')
          }, null, 8, ["modelValue", "errors"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Field, {
            field_name: "Messaggio",
            errors: _ctx.getErrors('messaggio')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_editor, {
                modelValue: _ctx.content,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.content) = $event)),
                "api-key": "no-api-key",
                init: {
                 height: 300,
                 width: '100%',
                 menubar: false,
                 content_css: '/css/tinymce.css',
                 plugins: [
                   'advlist autolink lists link charmap print preview anchor codesample',
                   'searchreplace visualblocks code fullscreen',
                   'insertdatetime media table paste code help wordcount'
                 ],
                 toolbar:
                   'undo redo | h1 h2 | bold italic codesample | \
                   alignleft aligncenter alignright alignjustify | \
                   bullist numlist | removeformat'
               }
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["errors"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_NextButton, {
            variant: "primary",
            onClick: _ctx.sendSupport,
            class: "w-48 text-sm sm:block py-2 px-4 ml-3"
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("Invia ")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ], 512), [
        [_vShow, _ctx.state == 0]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_6, [
        _cache[6] || (_cache[6] = _createTextVNode(" Grazie! La tua richiesta è stata inviata correttamente ")),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_NextButton, {
            variant: "outline-secondary",
            component: "router-link",
            to: {name:'Home'},
            class: "sm:block py-1 px-3"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode(" Torna alla home ")
            ])),
            _: 1
          })
        ])
      ], 512), [
        [_vShow, _ctx.state == 1]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Alert, null, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createTextVNode("Qualcosa è andato storto, riprova più tardi o contatta l'assistenza.")
          ])),
          _: 1
        }),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_NextButton, {
            variant: "outline-secondary",
            component: "router-link",
            to: {name:'Home'},
            class: "sm:block py-1 px-3"
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode(" Torna alla home ")
            ])),
            _: 1
          })
        ])
      ], 512), [
        [_vShow, _ctx.state == 2]
      ])
    ])
  ], 64))
}